import React, { useEffect, useState } from 'react'
import { GuestInfoProps } from '../../interfaces'
import BasicInput2 from '../ui/BasicInput2'
import { isEmailValid, isOnlyLetters } from '../../utils'
import { isValidPhoneNumber } from 'react-phone-number-input'
import InputPhoneNumber from '../common/InputPhoneNumber'

interface Props {
  handleUpdateGuestInfo: (_guestInfo: GuestInfoProps) => void
  handleUpdateIsDisabled: (_isDisabled: boolean) => void
  loading?: boolean
  guestInfo: GuestInfoProps
}

const SelectContactInfo: React.FC<Props> = ({ handleUpdateGuestInfo, handleUpdateIsDisabled, loading, guestInfo }) => {
  const [firstName, setFirstName] = useState<string>(guestInfo?.firstName || '')
  const [lastName, setLastName] = useState<string>(guestInfo?.lastName || '')
  const [email, setEmail] = useState<string>(guestInfo?.email || '')
  const [phone, setPhone] = useState<string>(guestInfo?.phone || '')
  const [errorMsg, setErrorMsg] = useState({ firstName: '', lastName: '', email: '', phone: '' })

  useEffect(() => {
    handleUpdateIsDisabled(
      !firstName ||
        !lastName ||
        !email ||
        !phone ||
        !isOnlyLetters(firstName) ||
        !isOnlyLetters(lastName) ||
        !isEmailValid(email) ||
        !isValidPhoneNumber(phone)
    )
    handleUpdateGuestInfo({ firstName, lastName, email, phone })
  }, [firstName, lastName, email, phone])

  const onChangeFirstName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFirstName(event.target.value)
    setErrorMsg((prevState) => ({ ...prevState, firstName: '' }))
  }
  const onChangeLastName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLastName(event.target.value)
    setErrorMsg((prevState) => ({ ...prevState, lastName: '' }))
  }

  const onChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value)
    setErrorMsg((prevState) => ({ ...prevState, email: '' }))
  }

  const onBlurFirstName = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!isOnlyLetters(event.target.value)) {
      setErrorMsg((prevState) => ({
        ...prevState,
        firstName: 'Please enter letters only.',
      }))
    }
  }
  const onBlurLastName = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!isOnlyLetters(event.target.value)) {
      setErrorMsg((prevState) => ({
        ...prevState,
        lastName: 'Please enter letters only.',
      }))
    }
  }

  const onBlurEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!isEmailValid(event.target.value)) {
      setErrorMsg((prevState) => ({
        ...prevState,
        email: 'Please enter a valid email.',
      }))
    }
  }
  const onBlurPhone = () => {
    if (!isValidPhoneNumber(phone || '')) {
      setErrorMsg((prevState) => ({
        ...prevState,
        phone: 'Please enter a valid phone number.',
      }))
    }
  }
  const renderErrorMessage = (msg: string) => {
    return <span className={'dtravel-inter-400 text-red mt-2 ml-2 text-12-12'}>{msg}</span>
  }

  return (
    <div className={'flex dtravel-flex-col dtravel-gap-12'}>
      <p>Contact information</p>
      <div className={'dtravel-center-horizontal dtravel-flex-between dtravel-gap-8 dtravel-w-full'}>
        <div className={'w-1/2'}>
          <BasicInput2
            placeholder={'First name'}
            value={firstName}
            onChange={onChangeFirstName}
            onBlur={onBlurFirstName}
            maxLength={25}
            readOnly={loading}
          />
          {errorMsg.firstName && renderErrorMessage(errorMsg.firstName)}
        </div>
        <div className={'w-1/2'}>
          <BasicInput2
            placeholder={'Last name'}
            value={lastName}
            onChange={onChangeLastName}
            onBlur={onBlurLastName}
            maxLength={25}
            readOnly={loading}
          />
          {errorMsg.lastName && renderErrorMessage(errorMsg.lastName)}
        </div>
      </div>

      <div>
        <InputPhoneNumber
          phone={phone}
          onChange={(phoneValue: any) => {
            setPhone(phoneValue)
            setErrorMsg((prevState) => ({ ...prevState, phone: '' }))
          }}
          handleBlur={onBlurPhone}
        />
        {errorMsg.phone && renderErrorMessage(errorMsg.phone)}
      </div>

      <div>
        <BasicInput2
          placeholder={'Email'}
          value={email}
          onChange={onChangeEmail}
          onBlur={onBlurEmail}
          readOnly={loading}
        />
        {errorMsg.email && renderErrorMessage(errorMsg.email)}
      </div>

      <p className={'dtravel-inter-400 dtravel-text-12-16 dtravel-neutral-500'}>
        The booking confirmation will be sent to this email address.
      </p>
    </div>
  )
}

export default SelectContactInfo
